import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <section class="tag-info">
  {{#if this.tagInfo}}
    <div class="tag-name">
      {{#if this.editing}}
        <div class="edit-tag-wrapper">
          <TextField
            @id="edit-name"
            @value={{readonly this.tagInfo.name}}
            @maxlength={{this.siteSettings.max_tag_length}}
            @input={{with-event-value (fn (mut this.newTagName))}}
            @autofocus="true"
          />

          <Textarea
            id="edit-description"
            @value={{readonly this.tagInfo.descriptionWithNewLines}}
            placeholder={{i18n "tagging.description"}}
            maxlength={{1000}}
            {{on "input" (with-event-value (fn (mut this.newTagDescription)))}}
            autofocus="true"
          />

          <div class="edit-controls">
            {{#unless this.updateDisabled}}
              <DButton
                @action={{action "finishedEditing"}}
                @icon="check"
                @ariaLabel="tagging.save"
                class="btn-primary submit-edit"
              />
            {{/unless}}
            <DButton
              @action={{action "cancelEditing"}}
              @icon="times"
              @ariaLabel="cancel"
              class="btn-default cancel-edit"
            />
          </div>
        </div>
      {{else}}
        <div class="tag-name-wrapper">
          {{discourse-tag this.tagInfo.name tagName="div"}}
          {{#if this.canAdminTag}}
            <a
              href
              {{on "click" this.edit}}
              class="edit-tag"
              title={{i18n "tagging.edit_tag"}}
            >{{d-icon "pencil-alt"}}</a>
          {{/if}}
        </div>
        {{#if this.tagInfo.description}}
          <div class="tag-description-wrapper">
            <span>{{html-safe this.tagInfo.description}}</span>
          </div>
        {{/if}}
      {{/if}}
    </div>
    <div class="tag-associations">
      {{~#if this.tagInfo.tag_group_names}}
        {{this.tagGroupsInfo}}
      {{/if~}}
      {{~#if this.tagInfo.categories}}
        {{this.categoriesInfo}}
        <br />
        {{#each this.tagInfo.categories as |category|}}
          {{category-link category}}
        {{/each}}
      {{/if~}}
      {{~#if this.nothingToShow}}
        {{#if this.tagInfo.category_restricted}}
          {{i18n "tagging.category_restricted"}}
        {{else}}
          {{html-safe (i18n "tagging.default_info")}}
          {{#if this.canAdminTag}}
            {{html-safe (i18n "tagging.staff_info" basePath=(base-path))}}
          {{/if}}
        {{/if}}
      {{/if~}}
    </div>
    {{#if this.tagInfo.synonyms}}
      <div class="synonyms-list">
        <h3>{{i18n "tagging.synonyms"}}</h3>
        <div>{{html-safe
            (i18n
              "tagging.synonyms_description" base_tag_name=this.tagInfo.name
            )
          }}</div>
        <div class="tag-list">
          {{#each this.tagInfo.synonyms as |tag|}}
            <div class="tag-box">
              {{discourse-tag tag.id pmOnly=tag.pmOnly tagName="div"}}
              {{#if this.editSynonymsMode}}
                <a
                  href
                  {{on "click" (fn this.unlinkSynonym tag)}}
                  class="unlink-synonym"
                >
                  {{d-icon "unlink" title="tagging.remove_synonym"}}
                </a>
                <a
                  href
                  {{on "click" (fn this.deleteSynonym tag)}}
                  class="delete-synonym"
                >
                  {{d-icon "far-trash-alt" title="tagging.delete_tag"}}
                </a>
              {{/if}}
            </div>
          {{/each}}
        </div>
      </div>
    {{/if}}
    {{#if this.editSynonymsMode}}
      <section class="add-synonyms field">
        <label for="add-synonyms">{{i18n "tagging.add_synonyms_label"}}</label>
        <div class="add-synonyms__controls">
          <TagChooser
            @id="add-synonyms"
            @tags={{this.newSynonyms}}
            @blockedTags={{array this.tagInfo.name}}
            @everyTag={{true}}
            @excludeSynonyms={{true}}
            @excludeHasSynonyms={{true}}
            @unlimitedTagCount={{true}}
            @allowCreate={{true}}
          />
          {{#if this.newSynonyms}}
            <DButton
              @action={{action "addSynonyms"}}
              @disabled={{this.addSynonymsDisabled}}
              @icon="check"
              class="ok"
            />
          {{/if}}
        </div>
      </section>
    {{/if}}
    {{#if this.canAdminTag}}
      <PluginOutlet
        @name="tag-custom-settings"
        @outletArgs={{hash tag=this.tagInfo}}
        @connectorTagName="section"
      />

      <div class="tag-actions">
        <DButton
          @action={{action "toggleEditControls"}}
          @icon="cog"
          @label="tagging.edit_synonyms"
          id="edit-synonyms"
          class="btn-default"
        />
        {{#if this.canAdminTag}}
          <DButton
            @action={{action "deleteTag"}}
            @icon="far-trash-alt"
            @label="tagging.delete_tag"
            id="delete-tag"
            class="btn-danger delete-tag"
          />
        {{/if}}
      </div>
    {{/if}}
  {{/if}}
  {{#if this.loading}}
    <div>{{i18n "loading"}}</div>
  {{/if}}
</section>
*/
{
  "id": "qYsD1m3s",
  "block": "[[[10,\"section\"],[14,0,\"tag-info\"],[12],[1,\"\\n\"],[41,[30,0,[\"tagInfo\"]],[[[1,\"    \"],[10,0],[14,0,\"tag-name\"],[12],[1,\"\\n\"],[41,[30,0,[\"editing\"]],[[[1,\"        \"],[10,0],[14,0,\"edit-tag-wrapper\"],[12],[1,\"\\n          \"],[8,[39,1],null,[[\"@id\",\"@value\",\"@maxlength\",\"@input\",\"@autofocus\"],[\"edit-name\",[28,[37,2],[[30,0,[\"tagInfo\",\"name\"]]],null],[30,0,[\"siteSettings\",\"max_tag_length\"]],[28,[37,3],[[28,[37,4],[[28,[37,5],[[30,0,[\"newTagName\"]]],null]],null]],null],\"true\"]],null],[1,\"\\n\\n          \"],[8,[39,6],[[24,1,\"edit-description\"],[16,\"placeholder\",[28,[37,7],[\"tagging.description\"],null]],[16,\"maxlength\",1000],[24,\"autofocus\",\"true\"],[4,[38,8],[\"input\",[28,[37,3],[[28,[37,4],[[28,[37,5],[[30,0,[\"newTagDescription\"]]],null]],null]],null]],null]],[[\"@value\"],[[28,[37,2],[[30,0,[\"tagInfo\",\"descriptionWithNewLines\"]]],null]]],null],[1,\"\\n          \"],[10,0],[14,0,\"edit-controls\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"updateDisabled\"]]],[[[1,\"              \"],[8,[39,10],[[24,0,\"btn-primary submit-edit\"]],[[\"@action\",\"@icon\",\"@ariaLabel\"],[[28,[37,11],[[30,0],\"finishedEditing\"],null],\"check\",\"tagging.save\"]],null],[1,\"\\n\"]],[]],null],[1,\"            \"],[8,[39,10],[[24,0,\"btn-default cancel-edit\"]],[[\"@action\",\"@icon\",\"@ariaLabel\"],[[28,[37,11],[[30,0],\"cancelEditing\"],null],\"times\",\"cancel\"]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"tag-name-wrapper\"],[12],[1,\"\\n          \"],[1,[28,[35,12],[[30,0,[\"tagInfo\",\"name\"]]],[[\"tagName\"],[\"div\"]]]],[1,\"\\n\"],[41,[30,0,[\"canAdminTag\"]],[[[1,\"            \"],[11,3],[24,6,\"\"],[24,0,\"edit-tag\"],[16,\"title\",[28,[37,7],[\"tagging.edit_tag\"],null]],[4,[38,8],[\"click\",[30,0,[\"edit\"]]],null],[12],[1,[28,[35,13],[\"pencil-alt\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"],[41,[30,0,[\"tagInfo\",\"description\"]],[[[1,\"          \"],[10,0],[14,0,\"tag-description-wrapper\"],[12],[1,\"\\n            \"],[10,1],[12],[1,[28,[35,14],[[30,0,[\"tagInfo\",\"description\"]]],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"tag-associations\"],[12],[41,[30,0,[\"tagInfo\",\"tag_group_names\"]],[[[1,\"        \"],[1,[30,0,[\"tagGroupsInfo\"]]],[1,\"\\n\"]],[]],null],[41,[30,0,[\"tagInfo\",\"categories\"]],[[[1,\"        \"],[1,[30,0,[\"categoriesInfo\"]]],[1,\"\\n        \"],[10,\"br\"],[12],[13],[1,\"\\n\"],[42,[28,[37,16],[[28,[37,16],[[30,0,[\"tagInfo\",\"categories\"]]],null]],null],null,[[[1,\"          \"],[1,[28,[35,17],[[30,1]],null]],[1,\"\\n\"]],[1]],null]],[]],null],[41,[30,0,[\"nothingToShow\"]],[[[41,[30,0,[\"tagInfo\",\"category_restricted\"]],[[[1,\"          \"],[1,[28,[35,7],[\"tagging.category_restricted\"],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,14],[[28,[37,7],[\"tagging.default_info\"],null]],null]],[1,\"\\n\"],[41,[30,0,[\"canAdminTag\"]],[[[1,\"            \"],[1,[28,[35,14],[[28,[37,7],[\"tagging.staff_info\"],[[\"basePath\"],[[28,[37,18],null,null]]]]],null]],[1,\"\\n\"]],[]],null]],[]]]],[]],null],[13],[1,\"\\n\"],[41,[30,0,[\"tagInfo\",\"synonyms\"]],[[[1,\"      \"],[10,0],[14,0,\"synonyms-list\"],[12],[1,\"\\n        \"],[10,\"h3\"],[12],[1,[28,[35,7],[\"tagging.synonyms\"],null]],[13],[1,\"\\n        \"],[10,0],[12],[1,[28,[35,14],[[28,[37,7],[\"tagging.synonyms_description\"],[[\"base_tag_name\"],[[30,0,[\"tagInfo\",\"name\"]]]]]],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"tag-list\"],[12],[1,\"\\n\"],[42,[28,[37,16],[[28,[37,16],[[30,0,[\"tagInfo\",\"synonyms\"]]],null]],null],null,[[[1,\"            \"],[10,0],[14,0,\"tag-box\"],[12],[1,\"\\n              \"],[1,[28,[35,12],[[30,2,[\"id\"]]],[[\"pmOnly\",\"tagName\"],[[30,2,[\"pmOnly\"]],\"div\"]]]],[1,\"\\n\"],[41,[30,0,[\"editSynonymsMode\"]],[[[1,\"                \"],[11,3],[24,6,\"\"],[24,0,\"unlink-synonym\"],[4,[38,8],[\"click\",[28,[37,4],[[30,0,[\"unlinkSynonym\"]],[30,2]],null]],null],[12],[1,\"\\n                  \"],[1,[28,[35,13],[\"unlink\"],[[\"title\"],[\"tagging.remove_synonym\"]]]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[11,3],[24,6,\"\"],[24,0,\"delete-synonym\"],[4,[38,8],[\"click\",[28,[37,4],[[30,0,[\"deleteSynonym\"]],[30,2]],null]],null],[12],[1,\"\\n                  \"],[1,[28,[35,13],[\"far-trash-alt\"],[[\"title\"],[\"tagging.delete_tag\"]]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\"]],[2]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"editSynonymsMode\"]],[[[1,\"      \"],[10,\"section\"],[14,0,\"add-synonyms field\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,\"for\",\"add-synonyms\"],[12],[1,[28,[35,7],[\"tagging.add_synonyms_label\"],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"add-synonyms__controls\"],[12],[1,\"\\n          \"],[8,[39,19],null,[[\"@id\",\"@tags\",\"@blockedTags\",\"@everyTag\",\"@excludeSynonyms\",\"@excludeHasSynonyms\",\"@unlimitedTagCount\",\"@allowCreate\"],[\"add-synonyms\",[30,0,[\"newSynonyms\"]],[28,[37,20],[[30,0,[\"tagInfo\",\"name\"]]],null],true,true,true,true,true]],null],[1,\"\\n\"],[41,[30,0,[\"newSynonyms\"]],[[[1,\"            \"],[8,[39,10],[[24,0,\"ok\"]],[[\"@action\",\"@disabled\",\"@icon\"],[[28,[37,11],[[30,0],\"addSynonyms\"],null],[30,0,[\"addSynonymsDisabled\"]],\"check\"]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"canAdminTag\"]],[[[1,\"      \"],[8,[39,21],null,[[\"@name\",\"@outletArgs\",\"@connectorTagName\"],[\"tag-custom-settings\",[28,[37,22],null,[[\"tag\"],[[30,0,[\"tagInfo\"]]]]],\"section\"]],null],[1,\"\\n\\n      \"],[10,0],[14,0,\"tag-actions\"],[12],[1,\"\\n        \"],[8,[39,10],[[24,1,\"edit-synonyms\"],[24,0,\"btn-default\"]],[[\"@action\",\"@icon\",\"@label\"],[[28,[37,11],[[30,0],\"toggleEditControls\"],null],\"cog\",\"tagging.edit_synonyms\"]],null],[1,\"\\n\"],[41,[30,0,[\"canAdminTag\"]],[[[1,\"          \"],[8,[39,10],[[24,1,\"delete-tag\"],[24,0,\"btn-danger delete-tag\"]],[[\"@action\",\"@icon\",\"@label\"],[[28,[37,11],[[30,0],\"deleteTag\"],null],\"far-trash-alt\",\"tagging.delete_tag\"]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[41,[30,0,[\"loading\"]],[[[1,\"    \"],[10,0],[12],[1,[28,[35,7],[\"loading\"],null]],[13],[1,\"\\n\"]],[]],null],[13]],[\"category\",\"tag\"],false,[\"if\",\"text-field\",\"readonly\",\"with-event-value\",\"fn\",\"mut\",\"textarea\",\"i18n\",\"on\",\"unless\",\"d-button\",\"action\",\"discourse-tag\",\"d-icon\",\"html-safe\",\"each\",\"-track-array\",\"category-link\",\"base-path\",\"tag-chooser\",\"array\",\"plugin-outlet\",\"hash\"]]",
  "moduleName": "discourse/components/tag-info.hbs",
  "isStrictMode": false
});